<template>
<div role="group" class="b-form-group form-group">
  <div class="form-row mb-lg">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('RECORDDATETIME')">
        <inputvalidation :formerror="formError" name="recordDateTime">
          <lb-vue-datetimepicker
            v-model="formData.recordDateTime"
            :translate-method="translateDateTimePicker"
            format="YYYY-MM-DD HH:mm:ss"
            display-format="DD.MM.YYYY HH:mm:ss"
            :isUTC="true"
            :simple="true">
            </lb-vue-datetimepicker>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row mb-lg">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('TITLE')">
        <inputvalidation :formerror="formError" name="title">
          <b-form-input type="text" v-model="formData.title"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row mb-lg">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('DESCRIPTION')">
        <inputvalidation :formerror="formError" name="description">
          <b-form-textarea v-model="formData.description" type="text" :rows="3" :max-rows="6"></b-form-textarea>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
</div>
</template>

<script>

export default
{
    name: 'ArrivalRecordForm',
    props: ['formData', 'formError'],
    data()
    {
        const me = this;
        return {
            pagination:
      {
          query: '',
          currentPage: 1,
          limit: 25,
          searchTimeout: false,
      },
            paginationWorkType:
      {
          query: '',
          currentPage: 1,
          limit: 25,
          searchTimeout: false,
          initialId: [],
      },
        };
    },
    created()
    {
        const me = this;
        me.getData();
        me.getWorkType();
    },
    methods:
  {
      translateDateTimePicker(val)
      {
          const me = this;
          return me.$t(val.toUpperCase());
      },
  },
    watch:
  {
  },
    computed:
  {
  },
};
</script>
